/**
 * @generated SignedSource<<f7860190d0a84a478b3b335c6bc90858>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFollowSearchProvider_itemSearch$data = {
  readonly canFollowSearch: boolean | null;
  readonly displayUriRef: string | null;
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly " $fragmentType": "SharedFollowSearchProvider_itemSearch";
};
export type SharedFollowSearchProvider_itemSearch$key = {
  readonly " $data"?: SharedFollowSearchProvider_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFollowSearchProvider_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFollowSearchProvider_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canFollowSearch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "d92af5a154d93b7ff1dda20b061672f3";

export default node;
